export default __webpack_public_path__ + "static/media/add-user.16447e05.svg";